import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import ResponsiveInputsList from '../../../common/forms/ResponsiveInputsList'
import { Form, Radio, Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types';

class InvestorDescription extends React.Component {
  static propTypes = {
    investorDescriptions: PropTypes.array,
    isInvalid: PropTypes.bool,
    message: PropTypes.string,
    investorDescriptionSelected: PropTypes.func.isRequired,
    selectedInvestorDescriptionId: PropTypes.number,
    showValidationErrors: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)
    this.renderDescriptionRadioButton = this.renderDescriptionRadioButton.bind(this)
    this.onRadioButtonValueChanged = this.onRadioButtonValueChanged.bind(this)
    this.isDescriptionChecked = this.isDescriptionChecked.bind(this)
  }

  isDescriptionChecked ({ investorDescriptionId }) {
    return investorDescriptionId === this.props.selectedInvestorDescriptionId
  }

  render () {
    const { message, isInvalid, showValidationErrors } = this.props
    const helpBlockStyles = styles['help-block-font-size'] +
      ' ' + styles['margin-left-auto'] +
      ' ' + styles['margin-right-auto'] +
      ' ' + 'alert alert-danger'

    return (
      <Row className={commonStyles['bg-grey']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section className={styles['padding-top-60'] + ' ' + styles['padding-bottom-describes']} id={'investorDescriptionContainer'}>
            <Form.Group className={styles['no-margin-bottom']}>
              <h3>Which of these best describes you?</h3>
              {message && showValidationErrors && <Form.Text className={helpBlockStyles}>{message}</Form.Text>}
              <ResponsiveInputsList
                list={this.props.investorDescriptions}
                renderFunction={(item, isChecked) => 
                  this.renderDescriptionRadioButton(item, isChecked)
                }
                isListItemChecked={this.isDescriptionChecked} />
            </Form.Group>
          </section>
        </Col>
      </Row>
    )
  }

  onRadioButtonValueChanged (event) {
    this.props.investorDescriptionSelected(parseInt(event.target.value))
  }

  renderDescriptionRadioButton ({ investorDescriptionId, description }, isChecked) {
    return <Form.Check 
    type='radio'
    name='investorDescription'
      key={investorDescriptionId}
      onChange={this.onRadioButtonValueChanged}
      checked={isChecked}
      value={investorDescriptionId}
      label={description}
      isInvalid={this.props.showValidationErrors && this.props.validation?.isInvalid}>
    </Form.Check>
  }
}

export default (InvestorDescription)
